import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useTheNodeSamlWorkListPageStore = defineStore('pages/TheNodeSamlWorkListPage', () => {
    const isLogout = ref(false);

    return {
        isLogout,
    };
});
